import { render, staticRenderFns } from "./NlpSubscribe.vue?vue&type=template&id=201d6b98&scoped=true"
import script from "./NlpSubscribe.vue?vue&type=script&lang=js"
export * from "./NlpSubscribe.vue?vue&type=script&lang=js"
import style0 from "./NlpSubscribe.vue?vue&type=style&index=0&id=201d6b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d6b98",
  null
  
)

export default component.exports